import {AbstractVisualFeature} from '../../visual-feature.js';
import {StaticPages} from '../static-pages.js';

import {foreignWindowFactory} from './foreign-window.js';

import PALETTE_SCHEMA from './foreign-window.palette-schema.yaml';

class ForeignWindowFeature extends AbstractVisualFeature {
    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return foreignWindowFactory(PALETTE);
    }
}

export const ForeignWindow = new ForeignWindowFeature(StaticPages);
